import { render, staticRenderFns } from "./edit_cate.vue?vue&type=template&id=2b1a48f3&scoped=true"
import script from "./edit_cate.vue?vue&type=script&lang=js"
export * from "./edit_cate.vue?vue&type=script&lang=js"
import style0 from "./edit_cate.vue?vue&type=style&index=0&id=2b1a48f3&prod&lang=css"
import style1 from "./edit_cate.vue?vue&type=style&index=1&id=2b1a48f3&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a48f3",
  null
  
)

export default component.exports